/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectPaymentDialogController', ProjectPaymentDialogController);

    ProjectPaymentDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'entityProject', 'BoardPayment', 'DateUtils', '$http'];

    function ProjectPaymentDialogController ($timeout, $scope, $uibModalInstance, entity, entityProject, BoardPayment, DateUtils, $http) {
        var vm = this;

        if (entityProject.closed) {
            $timeout(function() {
                clear();
            });
        }
        vm.payment = entity;
        vm.maxAmount = vm.payment.amount;
        if (vm.payment.parent !== null) {
            vm.maxAmount = vm.payment.amount + vm.payment.parent.amount;
        }
        vm.clear = clear;
        vm.save = save;
        vm.getDept = getDept;
        vm.copyPayment = copyPayment;
        vm.amountEditable = false;

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if(vm.payment.dept == "") {
                vm.payment.dept = null;
            }
            if(vm.payment.category == "") {
                vm.payment.category = null;
            }
            BoardPayment.update(vm.payment, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:paymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getDept(val) {
            return $http.get('api/_search/depts/', {
                params: {
                    query: val,
                    projectId: vm.payment.project.id
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function copyPayment() {
            $http.get('/api/payments/duplicate/', {
                params: {
                    paymentId: vm.payment.id
                }
            }).then(onSaveSuccess, onSaveError);
        }
    }
})();
